import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const dbAPI = {
    async GetData(type, page,limit=15,startDate="",endDate="", region="",keyword="",isOnlyPhone=false, onlySearchType=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/DB/GetData?type=${type}&siteType=1&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&region=${region}&keyword=${keyword}&isOnlyPhone=${isOnlyPhone}&onlySearchType=${onlySearchType}`);
        return responseModel
    },
    async GetSearchData(type, page, keyword=""){
        const responseModel = await JwtAxios.get(`/DB/GetSearchData?type=${type}&page=${page}&keyword=${keyword}`);
        return responseModel
    },
    async GetSummary(){
        const responseModel = await JwtAxios.get(`/DB/GetSummary?siteType=1`);
        return responseModel
    },
    async GetSummaryData(){
        const responseModel = await JwtAxios.get(`/DB/GetSummaryData?siteType=1`);
        return responseModel
    },
    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/DB/ExportExcel`,model);
        return responseModel
    },
    async ExportExcel2(model){
        const responseModel = await JwtAxios.download(`/DB/ExportExcel2`,model);
        return responseModel
    },
    async ExportExcelByPeriod(model){
        const responseModel = await JwtAxios.download(`/DB/ExportExcelByPeriod`,model);
        return responseModel
    },
}